__turbopack_context__.v({
  "className": "_5UnoxW_className",
  "variable": "_5UnoxW_variable",
});
